import React from 'react';
import { Banner, Layout, Paragraph, ParagraphHeader } from '@axiom/ui';
import type { CandidateEngagementDetails } from '@axiom/validation';

import { EnvUtil } from '../../utils/env-util';

import { EngagementsViewInterviewDetails } from './EngagementsViewInterviewDetails';

export type EngagementsViewStateBannerInterviewingUnacceptedProps = {
  engagement: CandidateEngagementDetails;
  interview: CandidateEngagementDetails['interviews'][number];
  name?: string;
};

export const EngagementsViewStateBannerInterviewingUnaccepted: React.FC<
  EngagementsViewStateBannerInterviewingUnacceptedProps
> = ({
  engagement,
  interview,
  name = 'ENGAGEMENTS_VIEW_STATE_BANNER_INTERVIEWING_UNACCEPTED',
}) => {
  return (
    <Banner name={name} type="critical" impact="high">
      <Layout direction="vertical" verticalGutter="24px">
        <ParagraphHeader name="INTERVIEWING_UNACCEPTED_HEADER">
          Next Step: Accept the interview request
        </ParagraphHeader>
        <Paragraph name="INTERVIEWING_UNACCEPTED_MESSAGE_1">
          Check your calendar or email
          {engagement.candidate.preferredEmail
            ? ` (${engagement.candidate.preferredEmail})`
            : null}{' '}
          and accept the meeting request. Go ahead and start preparing for your
          interview using{' '}
          <a href={EnvUtil.interviewGuideUrl} rel="noreferrer" target="_blank">
            Axiom's Interview Preparation Guidelines
          </a>
          .
        </Paragraph>
        {engagement.opportunity.ownerUser ? (
          <Paragraph name="INTERVIEWING_UNACCEPTED_MESSAGE_2">
            Questions about interview details or have last-minute issues? Reach
            out to the opportunity contact{' '}
            <a href={`mailto:${engagement.opportunity.ownerUser.email}`}>
              {engagement.opportunity.ownerUser.fullName}
            </a>
            .
          </Paragraph>
        ) : null}
        <EngagementsViewInterviewDetails
          interview={interview}
          name="ENGAGEMENT_VIEW_INTERVIEW_DETAILS"
        />
      </Layout>
    </Banner>
  );
};
